/**
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/** Class representing an issue encountered with a recommended server. */
class RecommendedServerIssue {
}
/** Class representing an issue with the returned product name. */
class ProductNameIssue extends RecommendedServerIssue {
    constructor(productName) {
        super();
        this.productName = productName;
    }
}
/** Class representing a slow response from a server. */
class SlowResponseIssue extends RecommendedServerIssue {
    constructor(responseTime) {
        super();
        this.responseTime = responseTime;
    }
}
/**
 * Class representing an issue with the system information.
 * This could be due to a networking error or invalid address.
 */
class SystemInfoIssue extends RecommendedServerIssue {
    constructor(error) {
        super();
        this.error = error;
    }
}
/** Class representing the version was missing from system information. */
class VersionMissingIssue extends RecommendedServerIssue {
}
/**
 * Class representing the server version is outdated.
 * (The version is lower than the generated client, but higher than the minimum supported.)
 */
class VersionOutdatedIssue extends RecommendedServerIssue {
    constructor(version) {
        super();
        this.version = version;
    }
}
/**
 * Class representing the server version is unsupported.
 * (The version is lower than the minimum supported.)
 */
class VersionUnsupportedIssue extends RecommendedServerIssue {
    constructor(version) {
        super();
        this.version = version;
    }
}

export { ProductNameIssue, RecommendedServerIssue, SlowResponseIssue, SystemInfoIssue, VersionMissingIssue, VersionOutdatedIssue, VersionUnsupportedIssue };
